import React from 'react';
import Helmet from 'react-helmet';
import { injectIntl } from '@kyruus/intl';
import { messages } from 'Src/shared/messages';

function MapSearchMetas({ search, intl }) {
  const getPageTitle = (search) => {
    if (!search.search_description) {
      return intl.formatMessage(messages.metaMapSearchPageTitleNoSearch);
    }
    return intl.formatMessage(messages.metaMapSearchPageTitle, {
      searchDescription: search.search_description
    });
  };
  return <Helmet title={getPageTitle(search)} />;
}

export default injectIntl(MapSearchMetas);
